import styled from '@emotion/styled'
import { Variants } from 'framer-motion'
import * as React from 'react'
import { BackButton, MotionFlex } from '..'
import { Version, Nav } from '..'
import { Flex, Text } from '@chakra-ui/core'
import { H4 } from '../../typography'

const PanelWrapper = styled(MotionFlex)`
  top: 0;
  left: 0;
  bottom: 0;
  width: 400px;
  display: block;
  padding-top: 5rem;
  max-width: 100%;
  position: fixed;
  overflow-y: auto;
  align-items: center;
  box-sizing: border-box;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  @media screen and (max-width: 768px) {
    width: 100%;
    position: fixed;
    margin: 0;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`

const variants: Variants = {
  hidden: {
    x: '-400px'
  },
  visible: {
    x: 0,
    transition: {
      type: 'spring',
      damping: 40
    }
  }
}
type SideSliderProps = {
  title?: string
  subTitle?: string
  goBack?: boolean
  children?: React.ReactNode
}

const SideSlider: React.FC<SideSliderProps> = ({ title, subTitle, goBack, children }) => {
  return (
    <PanelWrapper
      p={5}
      m={[5, 0]}
      bg="rgba(255, 255, 255, 0.95)"
      rounded={['md', 0]}
      initial="hidden"
      animate="visible"
      variants={variants}
    >
      <Nav />
      {goBack && (
        <Flex width="100%" justify="flex-start" align="center" mt={4}>
          <BackButton />
        </Flex>
      )}
      {(title || subTitle) && (
        <Flex width="100%" direction="column" justify="center" align="left">
          <H4 mt={6} textAlign="left" mb={6}>
            {title && (
              <Text as="b" fontSize="2xl" fontWeight="bold">
                {title}
              </Text>
            )}{' '}
            {subTitle && (
              <Text as="span" fontSize="sm">
                {subTitle}
              </Text>
            )}
          </H4>
        </Flex>
      )}
      {children}
      <Version position="absolute" bottom={0} right={0} p={4} w="100%" />
    </PanelWrapper>
  )
}

export default SideSlider
